import { GUESS_EVENT_LIMIT, GUESS_EVENT_MAX_MS, type GuessEvent, type GuessViewEvent } from './types';
import { validGuessViewEvent } from './guess-view';

/** 同一设备的未完成猜题；提交确认后只保留尚未上报的事件。 */
export interface GuessRecording {
  version: 1;
  startedAt: number;
  lastAt: number;
  events: GuessEvent[];
  viewEvents?: GuessViewEvent[];
  answer: string;
  picks: number[];
  typed: boolean;
  hintUsed: boolean;
}

export function readGuessRecording(value: unknown): GuessRecording | undefined {
  if (!value || typeof value !== 'object') return;
  const record = value as GuessRecording;
  if (record.version !== 1 || !Number.isSafeInteger(record.startedAt) || record.startedAt <= 0
    || !Number.isInteger(record.lastAt) || record.lastAt < 0 || record.lastAt > GUESS_EVENT_MAX_MS
    || typeof record.answer !== 'string' || record.answer.length > 120
    || typeof record.typed !== 'boolean' || typeof record.hintUsed !== 'boolean'
    || !Array.isArray(record.picks) || record.picks.length > 64 || record.picks.some(index => !Number.isInteger(index) || index < 0 || index > 64)
    || !Array.isArray(record.events) || record.events.length > GUESS_EVENT_LIMIT) return;
  let previous = 0;
  for (const event of record.events) {
    if (!event || !['pick', 'clear', 'type', 'hint', 'submit'].includes(event.kind)
      || !Number.isInteger(event.t) || event.t < previous || event.t > record.lastAt
      || (event.text !== undefined && (typeof event.text !== 'string' || event.text.length > 120))
      || (event.giveUp !== undefined && typeof event.giveUp !== 'boolean')) return;
    if (event.kind === 'pick' && [event.slot, event.index].some(n => !Number.isInteger(n) || n! < 0 || n! > 64)) return;
    previous = event.t;
  }
  if (record.viewEvents !== undefined) {
    if (!Array.isArray(record.viewEvents) || record.viewEvents.length > GUESS_EVENT_LIMIT) return;
    previous = 0;
    for (const event of record.viewEvents) {
      if (!validGuessViewEvent(event) || event.t < previous || event.t > record.lastAt) return;
      previous = event.t;
    }
  }
  return record;
}
